<div class="sm-flex sm-flex-col sm-whitespace-nowrap sm-font-normal sm-leading-5">
  <span class="sm-text-sm sm-font-bold">List Property:</span>
  <span data-test="referenced-list-id">Referenced List: {{ column.metadata.legacyListId }}</span>
  <span data-test="list-property-id">List Property: {{ column.data.itemId }}</span>
  <span data-test="list-property-type">Property Type: {{ listPropertyType }}</span>
</div>
